import React from "react";
import DatePicker from "react-datepicker-timechange";
import "react-datepicker-timechange/dist/react-datepicker.css";
import moment from "moment-timezone";

class QuickDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      existing: false,
      value: [],
      additionalToExclude: []
    };
  }

  componentWillReceiveProps(newProps) {}

  render() {
    return (
      <div className="date-picker">
        <DatePicker
          selected={this.props.selectedRdvDate}
          onChange={this.props.onChange}
          locale="fr"
          //  onTimeChange={this.props.onTimeChange}
          className="input"
          //  showTimeSelect

          dateFormat="DD/MM/YYYY"
          minDate={moment()}
          //    filterDate={this.isWeekday}
          /*maxDate={moment().add(
          this.props.getDoctorOptions.User.options.daysAhead,
          "days"
        )}*/
        />
      </div>
    );
  }
}

/*const GET_DOCTOR_OPTIONS = gql`
  query GetDoctorOptions($doctorId: ID!) {
    User(id: $doctorId) {
      options {
        baseDuration
        daysAhead
      }
    }
  }
`;
*/
export default /*graphql(GET_DOCTOR_OPTIONS, {
  name: "getDoctorOptions",
  options: ({ doctorId }) => ({ variables: { doctorId } })
})*/ QuickDatePicker;



// WEBPACK FOOTER //
// ./src/components/utilities/QuickDatePicker.js